import { Fragment, useEffect, useState } from "react";
import { fetchUserReviewList } from "../../../api/reviews/PlaintrReview";
import { json } from "react-router-dom";
import ReviewForm from "../../forms/ReviewForm";
import ReviewList from "./ReviewList";
import LoadingPlaceholder from "../loading/LoadingPlaceholder";
import { useRefreshOnAuth } from "../../../hooks/useRefreshOnAuth";

function LeftReview() {
  const [reviewList, setReviewList] = useState([]);
  const [loadingReviews, setLoadingReviews] = useState(true);

  async function getReviews() {
    let apiUrl = "review/plaintr-user-reviews";

    try {
      const response = await fetchUserReviewList(apiUrl);
      if (!response.ok) {
        throw json({ message: response.message }, { status: response.status });
      }

      const userReviewList = await response.json();
      setReviewList(userReviewList);
      setLoadingReviews(false);
    } catch {}
  }

  // This will reload the data on session restore without unmount/mount the components
  useRefreshOnAuth(getReviews);

  function handleSubmitState(value) {
    setLoadingReviews(value);
  }

  /**
   * Lets create the side effect to fetch the review list for the authenticated user
   */
  useEffect(() => {
    getReviews();
  }, [loadingReviews]);

  return (
    <Fragment>
      {loadingReviews && <LoadingPlaceholder />}
      {!loadingReviews && (
        <div id="reviewsPage">
          <ReviewForm handleSubmitState={handleSubmitState} />
          <ReviewList reviews={reviewList} />
        </div>
      )}
    </Fragment>
  );
}

export default LeftReview;
